<template>
  <div>
    <van-popup
      v-model="isVisible"
      round
    >
      <div class="content-box">
        <div class="title">支付提示</div>
        <div class="content">
          <div class="row">
            您当前使用的
            <span class="markedness">
              {{tipsInfo.payType == 'union' ? '银联支付收款' : '微信支付收款'  }}
            </span>
          </div>
          <div class="row">切换时间:{{ tipsInfo.changeDate }}</div>
          <div class="row">切换时间后的订单资金查询/提现</div>
          <div class="row">
            请返回点击“{{tipsInfo.payType == 'union' ? '银联商户号提现' : '微信钱包提现'}}”
          </div>
        </div>
        <div class="btn-box" @click="isVisible = false">关闭</div>
      </div>
  </van-popup>
  </div>
</template>

<script>
  export default {
    props: {
      isShowTipsPop: {
        type: Boolean,
        default: false
      },
      tipsInfo: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    computed: {
      isVisible: {
        get() {
          return this.isShowTipsPop
        },
        set(newVal,oldVal) {
          this.$emit('update:isShowTipsPop', newVal)
        }
      }
    },
    data() {
      return {

      }
    },
    
  }
</script>

<style lang="stylus" scoped>
  .content-box {
    width: 66vw;
    padding: 16px;
    height: 195px;
    .title {
      text-align: center;
      font-size: 17px;
      color: #333333;
      font-weight: bold;
    }
    .content {
      display: flex;
      flex-direction: column;
      // align-items: center;
      justify-content: center;
      font-size: 15px;
      color: #333333;
      margin-top: 16px;
      .row {
        margin-bottom: 6px;
      }
      .markedness {
        color: #FF6B31;
        font-weight: bold;
      }
    }
    .btn-box {
      height: 38px;
      line-height: 38px;
      text-align: center;
      color: #fff;
      background: linear-gradient( 180deg, #FF8820 0%, #FF6B31 100%);
      border-radius: 4px;
      margin-top: 20px;
      font-weight: bold;
    }
  }
</style>